// mixed series and movie IDs

export default {
	forPosters: ['tt10669608', 'tt10303430']
}
